import { Injectable, inject } from "@angular/core";
import { CachedApi } from "./cached-api";

export interface Role {
    _id: string;
    name: string;
    permissions: string[];
}

@Injectable({
    providedIn: 'root'
})
export class ProfileService {

    private api = inject(CachedApi);

    async getProfile() {
        return await this.api.get('/account/profile');
    }

    async getRoles() {
        return await this.api.get<Role[]>('/account/roles');
    }
}